import { camelCase } from 'lodash';

export function getError(
  fieldName: string,
  isTouched: Record<string, boolean>,
  errors: Record<string, string>
): string {
  return isTouched[fieldName] ? errors[fieldName] : '';
}

export function parseSaveErrors(errors: Record<string, string[]>) {
  const parsedErrors = {};
  Object.entries(errors).forEach(([key, value]) => {
    parsedErrors[camelCase(key)] = value[0];
  });
  return parsedErrors;
}
